// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profilesummary {
  padding: 0px 120px;
}

.btn-prfl {
  background-color: #55b56d;
  border-color: #55b56d;
  border-radius: 0px;
  font-family: "Poppins";
  color: #fff;
  padding: 8px 25px;
  margin-left: 10px;
}
:hover.btn-prfl {
  background-color: unset;
  color: #55b56d;
}
.prfl-frm label {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
}
.prfl-frm input {
  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);
  background-color: unset;
  border: 1px solid #55b56d;
  height: 50px;
  border-radius: 0px;
  background-color: #fff !important;
}
.prfl-frm input::placeholder {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 15px;
  color: #787272;
}
.prfl-frm-left img {
  width: 90%;
  margin: 0 auto;
  display: block;
}

.profilesummary .input input {
  position: relative;
  width: 100%;
  opacity: 1;
  border: 1px solid #E4E4E4;
  border-radius: 10px;
}

.profiless-img .input img {
  display: none;
}
.profiless-img #img1 {
  width: 100%;
  height: 40px;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  top: 65px;
  z-index: 11;
  left: 82px;
}
.profiless-img {
  position: relative;
}
.profiless-img i.fa.fa {
  /* background-color: #55b56d; */
  width: 40px;
  height: 40px;
  position: absolute;
  left: 428px;
  top: 68px;
  text-align: center;
  padding: 9px 8px;
  border-radius: 50%;
  color: #55b56d;
  z-index: 8;
}

.prfl-frm-mns textarea {

  background-color: unset;
  border: 1px solid #E4E4E4;
  border-radius: 10px;
  width: 100%;
  background-color: #fff;
}

.camping-hd h4 {
  color: #212121;
  font-size: 18px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}
.camping-hd p {
  color: #b5b5c3;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}
.btn-all {
  border-radius: 5px;
  background: #55b56d;
  color: #fff;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  /* width: 140px; */
  height: 41px;
  padding: 12px 15px;
}

.prfl-frm-mn {
  float: left;
  width: 48%;
  margin: 0 auto 0px 10px;
  
}

.prfl-frm-mns {
  padding-left: 10px;
  padding-right: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProfileSummary/ProfileSummary.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iDAAiD;EACjD,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,uBAAuB;;AAEzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".profilesummary {\r\n  padding: 0px 120px;\r\n}\r\n\r\n.btn-prfl {\r\n  background-color: #55b56d;\r\n  border-color: #55b56d;\r\n  border-radius: 0px;\r\n  font-family: \"Poppins\";\r\n  color: #fff;\r\n  padding: 8px 25px;\r\n  margin-left: 10px;\r\n}\r\n:hover.btn-prfl {\r\n  background-color: unset;\r\n  color: #55b56d;\r\n}\r\n.prfl-frm label {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 28px;\r\n}\r\n.prfl-frm input {\r\n  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);\r\n  background-color: unset;\r\n  border: 1px solid #55b56d;\r\n  height: 50px;\r\n  border-radius: 0px;\r\n  background-color: #fff !important;\r\n}\r\n.prfl-frm input::placeholder {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  line-height: 15px;\r\n  color: #787272;\r\n}\r\n.prfl-frm-left img {\r\n  width: 90%;\r\n  margin: 0 auto;\r\n  display: block;\r\n}\r\n\r\n.profilesummary .input input {\r\n  position: relative;\r\n  width: 100%;\r\n  opacity: 1;\r\n  border: 1px solid #E4E4E4;\r\n  border-radius: 10px;\r\n}\r\n\r\n.profiless-img .input img {\r\n  display: none;\r\n}\r\n.profiless-img #img1 {\r\n  width: 100%;\r\n  height: 40px;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  top: 65px;\r\n  z-index: 11;\r\n  left: 82px;\r\n}\r\n.profiless-img {\r\n  position: relative;\r\n}\r\n.profiless-img i.fa.fa {\r\n  /* background-color: #55b56d; */\r\n  width: 40px;\r\n  height: 40px;\r\n  position: absolute;\r\n  left: 428px;\r\n  top: 68px;\r\n  text-align: center;\r\n  padding: 9px 8px;\r\n  border-radius: 50%;\r\n  color: #55b56d;\r\n  z-index: 8;\r\n}\r\n\r\n.prfl-frm-mns textarea {\r\n\r\n  background-color: unset;\r\n  border: 1px solid #E4E4E4;\r\n  border-radius: 10px;\r\n  width: 100%;\r\n  background-color: #fff;\r\n}\r\n\r\n.camping-hd h4 {\r\n  color: #212121;\r\n  font-size: 18px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 21px;\r\n}\r\n.camping-hd p {\r\n  color: #b5b5c3;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 21px;\r\n}\r\n.btn-all {\r\n  border-radius: 5px;\r\n  background: #55b56d;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  /* width: 140px; */\r\n  height: 41px;\r\n  padding: 12px 15px;\r\n}\r\n\r\n.prfl-frm-mn {\r\n  float: left;\r\n  width: 48%;\r\n  margin: 0 auto 0px 10px;\r\n  \r\n}\r\n\r\n.prfl-frm-mns {\r\n  padding-left: 10px;\r\n  padding-right: 15px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
